module.exports = __webpack_public_path__ + "static/media/religion-min.02e7cd81.jpg";